export default __webpack_public_path__ + "static/media/seamless-native.402c2650.png";